import { apiCall } from './api'
import { Taller } from '../types/Taller'

export const getTaller = (codTaller: string): Promise<Taller> => {
  return apiCall(`${process.env.GATSBY_API_URL}/tienda/${codTaller}`, {
    method: 'GET',
  })
}
